











































































































































import Vue, { PropType } from "vue"
import CardListItem from "~/components/guideline/cardList/CardListItem.vue"
import FavoriteButton from "~/components/custom/profileList/local/PFavoriteButton.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import {
  UserProfileExperienceCorporationView,
  SkillTag,
  decorateUserProfileExperienceCorporationView,
} from "~/backendApis/viewModel"
import { priceFormat } from "~/plugins/priceFormatter"
import {
  RewardType,
  convertRewardTypeToLabel,
} from "~/backendApis/viewModel/userProfile"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"

interface Capability {
  title: string
  description: string
}

type ProfileItem =
  | "capabilities"
  | "skillTagList"
  | "career"
  | "selfIntroduction"

export default Vue.extend({
  components: {
    CardListItem,
    FavoriteButton,
    ConversionButton,
  },
  props: {
    linkPath: {
      type: String,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    mainJob: {
      type: String,
      default: null,
    },
    isFreelance: {
      type: Boolean,
      required: true,
    },
    availableUptimeName: {
      type: String,
      default: null,
    },
    availableHoursPerDay: {
      type: Number,
      default: null,
    },
    rewardType: {
      type: String,
      default: null,
    },
    minReward: {
      type: Number,
      default: null,
    },
    maxReward: {
      type: Number,
      default: null,
    },
    profileImageUrl: {
      type: String,
      default: null,
    },
    corporationName: {
      type: String,
      default: null,
    },
    isLeadingCompany: {
      type: Boolean,
      default: false,
    },
    lastAccessStatus: {
      type: String,
      default: null,
    },
    // 企業が在籍中の企業かどうかを示すフラグ
    isCurrentCorporation: {
      type: Boolean,
      default: null,
    },
    // 課題解決できること
    capabilities: {
      type: Array as PropType<Capability[]>,
      required: true,
    },
    skillTagList: {
      type: Array as PropType<SkillTag[]>,
      required: true,
    },
    // 経歴
    career: {
      type: Array as PropType<UserProfileExperienceCorporationView[]>,
      required: true,
    },
    selfIntroduction: {
      type: String,
      default: null,
    },
    // お気に入りされているかどうかを示すフラグ
    isFavorited: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    // 課題解決できること・スキルタグ・経歴・キャリアの概要という4項目の内、入力されている先頭2項目を取得する処理
    showableProfileItems(): ProfileItem[] {
      const showableItems = [] as ProfileItem[]
      if (this.capabilities.length > 0) {
        showableItems.push("capabilities")
      }
      if (this.skillTagList.length > 0) {
        showableItems.push("skillTagList")
      }
      if (this.career.length > 0) {
        showableItems.push("career")
      }
      if (this.selfIntroduction) {
        showableItems.push("selfIntroduction")
      }

      return showableItems.slice(0, 2)
    },
    isShowableCapabilities(): boolean {
      return this.showableProfileItems.includes("capabilities")
    },
    isShowableSkillTagList(): boolean {
      return this.showableProfileItems.includes("skillTagList")
    },
    isShowableCareer(): boolean {
      return this.showableProfileItems.includes("career")
    },
    isShowableSelfIntroduction(): boolean {
      return this.showableProfileItems.includes("selfIntroduction")
    },
    slicedCapabilities(): Capability[] {
      return this.$device.isMobile
        ? this.capabilities.slice(0, 2)
        : this.capabilities.slice(0, 3)
    },
    slicedCareer(): UserProfileExperienceCorporationView[] {
      return this.$device.isMobile
        ? this.career.slice(0, 3)
        : this.career.slice(0, 5)
    },
    availableUptimeAndHoursPerDayName(): string {
      return this.availableHoursPerDay
        ? `${this.availableUptimeName} ${this.availableHoursPerDay}時間/日`
        : String(this.availableUptimeName)
    },
    desiredRewardRange(): string {
      return this.rewardType
        ? `${
            this.rewardType === "negotiable"
              ? ""
              : `${convertRewardTypeToLabel(this.rewardType as RewardType)}`
          } ${
            this.rewardType === "hourly"
              ? `${this.minReward.toLocaleString()}円~`
              : this.rewardType === "monthly"
              ? `${priceFormat(Number(this.minReward))}円~`
              : ""
          }`
        : ""
    },
    isAvailableScout(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.USER_SCOUT)
    },
  },
  methods: {
    handleClickFavoriteIcon() {
      this.$emit("click-favorite-icon")
    },
    handleClickScoutButton() {
      this.$emit("click-scout-button")
    },
    getWorkSpanText(careerItem: UserProfileExperienceCorporationView): string {
      return this.$device.isMobile
        ? decorateUserProfileExperienceCorporationView(
            careerItem
          ).getSimpleWorkSpanText()
        : decorateUserProfileExperienceCorporationView(
            careerItem
          ).getWorkSpanText()
    },
    getSlicedSelfIntroduction(maxLength: number): string {
      return this.selfIntroduction.length > maxLength
        ? this.selfIntroduction.substring(0, maxLength) + "..."
        : this.selfIntroduction
    },
  },
})
